















/* Created- 11 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ActionListV2 from "@/Ui-Components/Common/List/ActionListV2.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../Models/Buttons";
import { eParticaAction, ParticaEvent, getActionName } from "../../Models/ParticaEvent";
import { ListItemDTO, PublicationModel } from "../../Generated/ParticaAPI";
import ParticaBaseView from "../Base/ParticaBaseView.vue";
import { IWrittenArticleService } from "../../BusinessServices/writtenarticles";
import ArticleFolder from "../../Ui-Components/Article/ArticleFolder.vue";

@Component(
	{
		name: "WrittenManager",
		components: {
			ParticaError,
			ParticaRowContainer,
			ActionListV2,
			ButtonList,
			ParticaCard,
			ArticleFolder
		}
	})
export default class WrittenManager extends ParticaBaseView {
	@Prop() private id: number;
	private folders: PublicationModel[] = [];
	private folder: PublicationModel = new PublicationModel();

	private writterArticleService: IWrittenArticleService;

	private buttons: ButtonConfig[] = [
		{ label: "Add Folder", action: eParticaAction.ARTICLE_FOLDER_SAVE, type: ButtonType.OK } as ButtonConfig,
		{ label: "Clear", action: eParticaAction.ARTICLE_FOLDER_CLEAR, type: ButtonType.Normal } as ButtonConfig
	] as ButtonConfig[];

	private listactions: ButtonConfig[] = [ // init our menu for the list.
		{ label: "Select", action: eParticaAction.ARTICLE_FOLDER_SELECT, type: ButtonType.OK } as ButtonConfig,
	];

	private listdata(): ListItemDTO[] {
		const items: ListItemDTO[] = new Array<ListItemDTO>();
		this.folders.forEach(folder => {
			if (folder.id !== undefined && folder.name !== undefined) {
				items.push({ id: folder.id.toString(), label: folder.name } as ListItemDTO);
			}
		});
		return items;
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.ARTICLE_FOLDER_SELECT: {
					const found: PublicationModel | undefined = this.folders.find(p => (p.id !== undefined && p.id.toString() === event.item.id));
					if (found !== undefined) {
						this.folder = found;
						this.buttons[0].label = "Rename Folder";
					}
					break;
				}
				case eParticaAction.ARTICLE_FOLDER_CLEAR: {
					this.folder = new PublicationModel();
					this.folder.id = 0;
					this.buttons[0].status = ButtonStatus.Enabled;
					this.buttons[0].label = "Add Folder";
					break;
				}
				case eParticaAction.ARTICLE_FOLDER_SAVE: {
					if (this.folder !== undefined && this.folder.name !== undefined) {
						if (this.folder.id === 0) {
							await this.writterArticleService.addFolder(this.id, this.folder.name);
						} else {
							await this.writterArticleService.updateFolderName(this.folder.id as number, this.folder.name);
						}
					}
					await this.init();
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.writterArticleService = this.particaServices.getWrittenArticleService();
			this.folders = await this.writterArticleService.getWrittenPublications(this.id);
			this.folder.id = 0;
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
